import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavigateButton } from '../../components';
import { Wrapper, Logo, RightPart } from './styled';
export const TopBar = () => {
    return (_jsxs(Wrapper, { children: [_jsx(Logo, { to: '/welcome', children: "Perch.dev" }), _jsxs(RightPart, { children: [_jsx(NavigateButton, { to: '/apifetcher', children: "API Fetcher" }), _jsx(NavigateButton, { to: '/calculator', children: "Calculator" }), _jsx(NavigateButton, { to: '/paint', children: "Paint" })] })] }));
};
